// @flow

import { rem } from 'polished';
import styled from 'styled-components';

import COLORS from 'client/constants/colors';
import Translate from 'client/components/translate';

export const ModifyPlanLinksContainer = styled.div`
  display: flex;
  padding-bottom: 1rem;

  .button {
    padding: 0;
  }
`;

export const LinkTranslate = styled(Translate)`
  color: ${COLORS.NEUTRAL_900};
  font-size: ${rem(14)};
  font-weight: 700;
`;
